module.exports = __webpack_public_path__ + "img/visa.68ae1db2.svg";